/**
 * External dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

export const productBlouse = (
	<SVG xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
		<Path
			d="M31.9489 8.0315H25.014V4.69394H23.6479C22.7194 4.69394 22.3285 4.22477 22.3285 3.35313C22.3285 2.48149 22.7194 2.01232 23.6479 2.01232C24.1122 2.01232 26.0292 1.99676 26.0292 1.99676V0L23.2059 0.0155649C21.2001 0.0155649 20.0361 1.36304 20.0361 3.35313C20.0361 5.34322 21.1379 6.62176 23.0393 6.69514V8.0315H16.0489C16.0489 8.0315 8.03223 11.7804 8.03223 12.0117H40.0189C40.0189 11.7804 31.9467 8.0315 31.9467 8.0315H31.9489Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M48 18.0133C48 18.0133 40.1144 10.4243 38.8838 9.47037C37.8242 8.64988 36.5292 8.01172 34.0103 8.01172H31.9489C31.6335 12.1987 28.266 15.494 23.9989 15.494C19.7318 15.494 16.3643 12.1987 16.0489 8.01172H13.9875C11.4686 8.01172 10.1735 8.64766 9.11398 9.47037C7.8856 10.4243 0 18.0133 0 18.0133L2.72553 26.0181H9.95807L9.95141 48.0025H38.0508L38.0442 26.0181H45.2767L48.0022 18.0133H48Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
	</SVG>
);
